export default "__VITE_ASSET__B8AFQ9Ls__"